import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './SplashScreen.css';

interface SplashScreenProps {
  show: boolean;
}

/**
 * Full-screen splash screen / loading curtain
 * Shows while initial CMS data is loading to prevent flash of old content
 */
const SplashScreen: React.FC<SplashScreenProps> = ({ show }) => {
  if (!show) return null;

  return (
    <div className="splash-screen">
      <div className="splash-content">
        {/* BRAI logo/branding */}
        <div className="splash-logo">
          <div className="brai-logo-container">
            <div className="brai-logo-square">
              <span className="brai-logo-letter">B</span>
            </div>
          </div>
          <h1 className="splash-title">BRAI</h1>
          <p className="splash-subtitle">Brand Intelligence</p>
        </div>

        {/* Loading indicator */}
        <div className="splash-loading">
          <Spin
            indicator={<LoadingOutlined style={{ fontSize: 32, color: 'white' }} spin />}
          />
          <p className="splash-text">Loading your experience...</p>
        </div>

        {/* Optional: Progress bar or skeleton */}
        <div className="splash-progress">
          <div className="progress-bar">
            <div className="progress-fill"></div>
          </div>
        </div>
      </div>

      {/* Branded background */}
      <div className="splash-background">
        <div className="bg-shape bg-shape-1"></div>
        <div className="bg-shape bg-shape-2"></div>
        <div className="bg-shape bg-shape-3"></div>
      </div>
    </div>
  );
};

export default SplashScreen;
